var _a, _b;
export const ACCOUNT_USAGE_LINK = {
    href: '/app/settings/billing',
    icon: { selected: 'miscWallet', unselected: 'miscWallet' },
    text: 'Usage',
};
export const FALLBACK_SIDEBAR_RESPONSE = {
    itemGroups: [
        [
            {
                href: '/app/home',
                icon: 'navHome',
                iconFilled: 'navHomeFill',
                text: 'Home',
            },
            {
                href: '/app/templates',
                icon: 'navExplore',
                iconFilled: 'navExploreFill',
                text: 'Discover',
            },
        ],
        [
            {
                href: '/app/assets/zaps',
                icon: 'miscBoltAltFill',
                iconFilled: 'miscBoltAltFill',
                text: 'Zaps',
            },
            {
                href: `https://tables.zapier.com/app/tables?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier`,
                icon: 'navTables',
                iconFilled: 'navTables',
                text: 'Tables',
            },
            {
                href: `https://interfaces.zapier.com/interfaces?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier/`,
                icon: 'navInterfaces',
                iconFilled: 'navInterfaces',
                text: 'Interfaces',
            },
            {
                href: '/app/chatbots',
                text: 'Chatbots',
                icon: 'navAIChatbot',
                iconFilled: 'navAIChatbot',
                tag: 'Beta',
            },
            {
                href: '/app/canvas',
                text: 'Canvas',
                icon: 'navCanvas',
                iconFilled: 'navCanvas',
                tag: 'Beta',
            },
            {
                href: 'https://agents.zapier.com/?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier',
                text: 'Agents',
                icon: 'navCentral',
                iconFilled: 'navCentral',
                tag: 'Beta',
                target: '_blank',
            },
        ],
        [
            {
                href: '/app/connections',
                icon: 'navApps',
                iconFilled: 'navAppsFill',
                text: 'Apps',
            },
            {
                href: '/app/history',
                icon: 'miscClock',
                iconFilled: 'miscClockFill',
                text: 'Zap History',
            },
        ],
    ],
    moreLinks: {
        text: 'More',
        icon: 'navMoreHoriz',
        moreLinksItems: [
            {
                description: 'Build automations with code.',
                href: 'https://functions.zapier.com/?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier',
                icon: 'navFunctions',
                iconFilled: 'navFunctions',
                tag: 'Alpha',
                text: 'Functions',
            },
            {
                description: 'Integrate your app into Zapier.',
                href: '/platform',
                icon: 'actionBuild',
                iconFilled: 'actionBuild',
                text: 'Developer platform',
            },
        ],
    },
    createOptions: [
        {
            title: 'Zaps',
            description: 'Automated workflows',
            href: '/webintent/create-zap?entry-point-method=make_a_zap_call_to_action',
            icon: 'miscBoltAltFill',
            iconFilled: 'miscBoltAltFill',
            id: 'Zaps',
        },
        {
            title: 'Tables',
            description: 'Automated data storage',
            href: `https://tables.${(_a = process.env.ZAPIER_DOMAIN) !== null && _a !== void 0 ? _a : 'zapier.com'}/app/tables?modalOpen=create`,
            icon: 'navTables',
            iconFilled: 'navTables',
            id: 'Tables',
        },
        {
            title: 'Interfaces',
            description: 'Apps, forms, and pages',
            href: `https://interfaces.${(_b = process.env.ZAPIER_DOMAIN) !== null && _b !== void 0 ? _b : 'zapier.com'}/interfaces?modalOpen=create`,
            icon: 'navInterfaces',
            iconFilled: 'navInterfaces',
            id: 'Interfaces',
        },
        {
            title: 'Chatbots',
            description: 'AI-powered chatbot',
            href: `/app/chatbots?modalOpen=create`,
            icon: 'navAIChatbot',
            iconFilled: 'navAIChatbot',
            id: 'Chatbots',
            tag: 'Beta',
        },
        {
            title: 'Canvas',
            description: 'Process visualization',
            href: '/app/canvas/new',
            icon: 'navCanvas',
            iconFilled: 'navCanvas',
            id: 'Canvas',
            tag: 'Beta',
        },
    ],
};
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
